import { Component, Mixins } from 'vue-property-decorator';
import { AppFiltersMixin } from '@/mixins/AppFiltersMixin';
import { AppHypotheekMixin } from '../../mixins/AppHypotheekMixin';

@Component({})
export default class AppInBehandeling extends Mixins(AppFiltersMixin, AppHypotheekMixin) {
  public plural(singleText: string, pluralText: string): string {
    return this.hypotheek?.paidBetalingen.length === 1 ? singleText : pluralText;
  }
}
